import { React, useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Components/Loading";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const SalesReport = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [data, setData] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [listofpaymentmodes, setlistofpaymentmodes] = useState([]);
  const [selpaymentmode, setselpaymentmode] = useState("");
  const [listofdivisions, setlistofdivisions] = useState([]);
  const [seldivision, setseldivision] = useState("");
  const [listoftillno, setlistoftillno] = useState([]);
  const [seltillno, setseltillno] = useState("");
  const [unpaiddata, setunpaiddata] = useState([]);
  const [showunpaid, setShowunpaid] = useState(false);
  const [showpaid, setshowpaid] = useState(true);
  const divisionState = useSelector((state) => state.changeDivision);
  const [totalVat, setTotalVat] = useState(0);
  const [totalLevy, setTotalLevy] = useState(0);
  const [totalExcl, setTotalExcl] = useState(0);
  const [totalIncl, setTotalIncl] = useState(0);
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );

  const [search, setSearch] = useState("");
  const [startdate, setstartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());

  const filtCash = data.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const sDate = item.CREATEDDATE;
    const eDate = item.CREATEDDATE;

    if (searchData?.length === 0 &&
      !startdate &&
      !enddate
    ) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "SALETYPE",
        "CLIENT",
        "DIVISION",
        "BILLNO",
        "TABLENO",
        "WAITER",
        "SHIFT",
        "SALEHOUR",
        "CASHIER",
        "CURRENCY"
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    let vatTotal = 0;
    let levyTotal = 0;
    let exclTotal = 0;
    let inclTotal = 0;

    filtCash.forEach((item) => {
      vatTotal += parseFloat(item?.VATAMOUNT);
      levyTotal += parseFloat(item?.LEVYAMOUNT);
      exclTotal += parseFloat(item?.AMOUNTEXCVAT);
      inclTotal += parseFloat(item?.AMOUNT);
    });

    setTotalVat(vatTotal);
    setTotalLevy(levyTotal);
    setTotalExcl(exclTotal);
    setTotalIncl(inclTotal);
  }, [filtCash]);

  useEffect(() => {
    getCashSaleHistory();
  }, []);

  const ExcelPaid = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sales Report");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 25, 20, 15, 15, 25, 10,15, 25, 15,15,15,15];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "SALE TYPE",
      "CLIENT",
      "DIVISION",
      "BILL NO",
      "TABLE NO",
      "WAITER",
      "CREATED DATE",
      "DATE TIME",
      "SHIFT",
      "SALE HOUR",
      "AMOUNT EXCLUSIVE VAT",
      "LEVY AMOUNT",
      "VAT AMOUNT",
      "AMOUNT INCLUSIVE VAT",
      "CASH AMOUNT",
      "MPESA AMOUNT",
      "CREDIT CARD AMOUNT",
      "RECEIPT AMOUNT",
      "CASHIER",
      "CURRENCY",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Sales_Report.xlsx";
      link.click();
    });
  };

  const PdfPaid = () => {
    const doc = new jsPDF();

    doc.text("Sales Report", 10, 10);

    const columns = [
      "SALE TYPE",
      "CLIENT",
      "DIVISION",
      "BILL NO",
      "TABLE NO",
      "WAITER",
      "CREATED DATE",
      "DATE TIME",
      "SHIFT",
      "SALE HOUR",
      "AMOUNT EXCLUSIVE VAT",
      "LEVY AMOUNT",
      "VAT AMOUNT",
      "AMOUNT INCLUSIVE VAT",
      "CASH AMOUNT",
      "MPESA AMOUNT",
      "CREDIT CARD AMOUNT",
      "RECEIPT AMOUNT",
      "CASHIER",
      "CURRENCY",
    ];
    const data = filtCash.map((stock) => [
      stock.SALETYPE,
      stock.CLIENT,
      stock.DIVISION,
      stock.BILLNO,
      stock.TABLENO,
      stock.WAITER,
      moment(stock.CREATEDDATE).format("DD/MM/YYYY"),
      moment(stock.DATETIME).format("DD/MM/YYYY HH:mm:ss"),
      stock.SHIFT,
      stock.SALEHOUR,
      stock.AMOUNTEXCVAT,
      stock.LEVYAMOUNT,
      stock.VATAMOUNT,
      stock.AMOUNT,
      stock.CASHAMOUNT,
      stock.MPESAMOUNT,
      stock.CREDITCARDAMOUNT,
      stock.RECEIPTAMOUNT,
      stock.CASHIER,
      stock.CURRENCY,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Sales_Report.pdf");
  };

  const getCashSaleHistory = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1844`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setData(response.data);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching List Of Cash Sale History:", error);
        setisloading(false);
      });
  };

  return (
    <>
      <DashBoardNavbar />
      <HomePageNavbarFinancials />
      {isloading ? (
        <Loading />
      ) : (
        <div className="h-auto w-full mt-4">
          <div className="m-3  font-semibold">
            <p className="font-xl">My Sales for the day</p>
          </div>

          {/* First Row */}
          <div className="flex flex-row mt-2 mx-3 gap-2">
            <p className="">Search:</p>
            <input
              className="w-64 h-6 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            ></input>
            <p>From :</p>
            <input
              type="date"
              className="w-34 h-6 border-black border ml-2 mr-2 rounded"
              value={startdate.split("T")[0]}
              onChange={(e) => {
                setstartdate(e.target.value);
              }}
            ></input>
            <p>To :</p>
            <input
              type="date"
              className="w-34 h-6 border-black border ml-2 mr-2 rounded"
              value={enddate.split("T")[0]}
              onChange={(e) => {
                setEnddate(e.target.value);
              }}
            ></input>

            <div>
              <RiFileExcel2Line
                onClick={() => {
                  ExcelPaid();
                }}
                size={35}
              />
            </div>
            <div>
              {" "}
              <BsFileEarmarkPdf
                onClick={() => {
                  PdfPaid();
                }}
                size={35}
              />
            </div>
          </div>

          {/* Second Row */}
          <div className="w-full h-[350px] p-1 overflow-y-auto">
            <aside className="table__pos__app ">
              <table class="custom-table text-sm table_1">
                <thead class="header-cell">
                  <tr>
                    <td className="text-left">SALES TYPE</td>
                    <td className="text-left">CLIENT</td>
                    <td className="text-left">DIVISON</td>
                    <td className="text-right">BILL NO</td>
                    <td className="text-right">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">CREATED DATE</td>
                    <td className="text-left">DATE TIME</td>
                    <td className="text-right">SHIFT</td>
                    <td className="text-right">SALE HOURS</td>
                    <td className="text-right">AMOUNT EXCLUSIVE VAT</td>
                    <td className="text-right">LEVY AMOUNT</td>
                    <td className="text-right">VAT AMOUNT</td>
                    <td className="text-right">AMOUNT INCLUSIVE VAT</td>
                    <td className="text-right">CASH AMOUNT</td>
                    <td className="text-right">MPESA AMOUNT</td>
                    <td className="text-right">CREDIT CARD AMOUNT</td>
                    <td className="text-right">RECEIPT AMOUNT</td>
                    <td className="text-left">CASHIER</td>
                    <td className="text-left">CURRENCY</td>
                  </tr>
                </thead>
                <tbody>
                  {filtCash.map((value, index) => (
                    <tr
                      className={
                        index < data.length
                          ? "border-b cursor-pointer text-sm table-row"
                          : ""
                      }
                    >
                      <td className="text-left">
                        {value.SALETYPE ? value.SALETYPE : ""}
                      </td>
                      <td className="text-left">
                        {value.CLIENT ? value.CLIENT : ""}
                      </td>
                      <td className="text-left">
                        {value.DIVISION ? value.DIVISION : ""}
                      </td>
                      <td className="text-right">
                        {value.BILLNO ? value.BILLNO : ""}
                      </td>
                      <td className="text-right">
                        {value.TABLENO ? value.TABLENO : ""}
                      </td>
                      <td className="text-left">
                        {value.WAITER ? value.WAITER : ""}
                      </td>
                      <td className="text-left">
                        {value.CREATEDDATE
                          ? moment(value.CREATEDDATE).format("DD/MM/YYYY")
                          : ""}
                      </td>
                      <td className="text-left">
                        {value.DATETIME
                          ? moment(value.DATETIME).format("DD/MM/YYYY hh:mm:ss")
                          : ""}
                      </td>

                      <td className="text-left">
                        {value.SHIFT ? value.SHIFT : ""}
                      </td>
                      <td className="text-left">
                        {value.SALEHOUR ? value.SALEHOUR : ""}
                      </td>
                      <td className="text-right">
                        {value?.AMOUNTEXCVAT
                          ? value?.AMOUNTEXCVAT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.LEVYAMOUNT
                          ? value?.LEVYAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.VATAMOUNT
                          ? value?.VATAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.AMOUNT
                          ? value?.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.CASHAMOUNT
                          ? value?.CASHAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.MPESAMOUNT
                          ? value?.MPESAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.CREDITCARDAMOUNT
                          ? value?.CREDITCARDAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {value?.RECEIPTAMOUNT
                          ? value?.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "N/A"}
                      </td>
                      <td className="text-left">
                        {value.CASHIER ? value.CASHIER : ""}
                      </td>
                      <td className="text-left">
                        {value.CURRENCY ? value.CURRENCY : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </aside>
          </div>

          <div className="flex flex-row mt-2 ml-2">
            <p className="ml-20">Total Vat:</p>
            <input
              className="w-48 h-6 border-black border"
              value={
                totalVat
                  ? totalVat.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : ""
              }
            ></input>
            <p className="ml-20">Total Levy:</p>
            <input
              className="w-48 h-6 border-black border"
              value={
                totalLevy
                  ? totalLevy.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : ""
              }
            ></input>
          </div>
          <div className="flex flex-row mt-2 ml-2">
            <p>Total Sales Exc Taxes:</p>
            <input
              className="w-48 h-6 border-black border"
              value={
                totalExcl
                  ? totalExcl.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : ""
              }
            ></input>
            <p className="ml-2">Total Sales Inc Taxes:</p>
            <input
              className="w-48 h-6 border-black border"
              value={
                totalIncl
                  ? totalIncl.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : ""
              }
            ></input>
          </div>
        </div>
      )}
    </>
  );
};

export default SalesReport;
